export const GET_MODAL_STATUS = 'modals/GET_MODAL_STATUS'
